export enum ShopifyOrderNoteAttributeName {
    shippingType = 'shippingType',
    shopAddress = 'shopAddress',
    mplTrackingNumber = 'MPL Tracking Number',
    mplPackageTrackingNumber = 'MPL Package Tracking Number',
    mplPrice = 'MPL Price',
    shopName = 'shopName',
    foxpostOperatorId = 'operatorId',
    clFoxId = 'clFoxId',
    packagePointId = 'packagePointId',
    glsParcelId = 'parcelId',
    glsParcelNumber = 'parcelNumber',
}
